import React, { useState, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import IconButton from '@mui/material/IconButton';
import { useDispatch } from 'react-redux';
import { createTableColumns } from '../../../utils/createTableColumns';
import { useGlobalTable } from '../../../hooks/useGlobalTable';
import AllderTable from '../../../components/AllderTable';
import { branchTagHandler } from '../../../redux/handlers';
import { TagModal, ConfirmDeleteModal, SuccessModal } from './modals';

export function TagDiscount() {
  const dispatch = useDispatch();
  const { businessSlug, branchID } = useParams();

  const [modalCreate, setModalCreate] = useState({
    open: false,
    x: 0,
    y: 0,
    width: 460,
    height: 360,
    pin: false,
    mode: 'normal',
    modalname: 'create'
  });

  const [modalEdit, setModalEdit] = useState({
    open: false,
    x: 0,
    y: 0,
    width: 470,
    height: 360,
    pin: false,
    mode: 'normal',
    modalname: 'edit'
  });

  const [modalConfirmDelete, setModalConfirmDelete] = useState({
    open: false,
    x: 0,
    y: 0,
    width: 470,
    height: 320,
    pin: false,
    mode: 'normal',
    modalname: 'delete'
  });

  const [modalSuccess, setModalSuccess] = useState({
    open: false,
    x: 0,
    y: 0,
    width: 470,
    height: 300,
    pin: false,
    mode: 'normal',
    modalname: 'success'
  });

  const [editdata, setEditdata] = useState({});
  const [successType, setSuccessType] = useState('delete');

  const handleDelete = row => {
    setEditdata(row);
    setModalConfirmDelete(prev => ({ ...prev, open: true }));
  };

  const handleEdit = row => {
    setEditdata(row);
    setModalEdit(prev => ({ ...prev, open: true }));
  };

  const handleCreate = () => {
    setEditdata({});
    setModalCreate(prev => ({ ...prev, open: true }));
  };

  const handleDeleteSuccess = () => {
    refreshBranchTags();
    setModalConfirmDelete(prev => ({ ...prev, open: false }));
    setSuccessType('delete');
    setModalSuccess(prev => ({ ...prev, open: true }));

    setEditdata({});
  };

  const handleCreateSuccess = () => {
    refreshBranchTags();
    setModalCreate(prev => ({ ...prev, open: false }));
    setSuccessType('create');
    setModalSuccess(prev => ({ ...prev, open: true }));
  };

  const handleEditSuccess = () => {
    refreshBranchTags();
    setModalEdit(prev => ({ ...prev, open: false }));
    setSuccessType('edit');
    setModalSuccess(prev => ({ ...prev, open: true }));
  };

  const columns = createTableColumns(
    [
      {
        field: 'tagName',
        headerName: 'ชื่อ TAG',
        width: 170,
        sortable: false,
        flex: 1,
        renderCell: ({ row }) => <div className="">{row.name || row.tagName}</div>
      },
      {
        field: 'tagDiscountType',
        headerName: 'ประเภทส่วนลด',
        width: 170,
        sortable: false,
        align: 'center',
        headerAlign: 'center',
        flex: 1,
        renderCell: ({ row }) => (
          <div>
            {row.discount_type === 'percent'
              ? 'เปอร์เซ็นต์'
              : row.discount_type === 'amount'
              ? 'บาท'
              : row.tagDiscountType || '-'}
          </div>
        )
      },
      {
        field: 'quantity',
        headerName: 'จำนวน',
        flex: 1,
        width: 140,
        sortable: false,
        align: 'center',
        headerAlign: 'center',
        renderCell: ({ row }) => <div>{row.discount_value || row.quantity || '-'}</div>
      },
      {
        field: 'actions',
        headerName: 'จัดการ',
        width: 250,
        sortable: false,
        align: 'center',
        headerAlign: 'center',
        type: 'actions'
      }
    ],
    row => (
      <div>
        <Button type="button" className="btn-edit-st-1" onClick={() => handleEdit(row)}></Button>
        <Button type="button" className="btn-delete-st-3 ml-2" onClick={() => handleDelete(row)}></Button>
      </div>
    )
  );

  const fetchBranchTags = useCallback(
    params => {
      return dispatch(
        branchTagHandler.getBranchTagPaginationList({
          businessSlug,
          branchId: branchID,
          ...params
        })
      );
    },
    [businessSlug, branchID, dispatch]
  );

  const {
    data: branchTags,
    loading,
    totalRows,
    paginationModel,
    setPaginationModel,
    handleSort,
    debouncedSearch,
    filterParams,
    refreshData: refreshBranchTags
  } = useGlobalTable({
    fetchData: fetchBranchTags,
    defaultSort: 'created_at',
    defaultOrder: 'desc',
    defaultPageSize: 10
  });

  return (
    <>
      <div>
        <div
          className="px-4 py-3 fw-bold"
          style={{ color: '#2DC76D', background: '#FFF', borderBottom: '1px solid rgba(76, 78, 100, 0.12)' }}
        >
          <IconButton size="small" className="!mt-[-4px] !mr-2" component={Link} to={-1}>
            <ArrowBackIosNewSharpIcon fontSize="inherit" />
          </IconButton>
          ตั้งค่า POS
        </div>

        <div className="card border-0 mx-auto mt-3 mb-3" style={{ width: '98%', borderRadius: '8px' }}>
          <div className="card-body py-4 px-0">
            <div className="fw-bold mb-1 px-4 text-[20px]" style={{ color: '#2DC76D' }}>
              Tag ส่วนลด
            </div>

            <div className="card-body px-0 py-4">
              <div className="d-flex align-items-center px-4 mb-4">
                <div className="me-3 ms-auto">
                  <input
                    type="text"
                    className="form-control form-st-4"
                    placeholder="ค้นหา ชื่อ"
                    onKeyUp={e => debouncedSearch(e.target.value)}
                  />
                </div>

                <Button type="button" className="btn btn btn-st-7" onClick={handleCreate}>
                  เพิ่ม TAG
                </Button>
              </div>

              <div>
                <AllderTable
                  data={branchTags}
                  loading={loading}
                  columns={columns}
                  totalRows={totalRows}
                  paginationModel={paginationModel}
                  setPaginationModel={setPaginationModel}
                  handleSort={handleSort}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="py-4"></div>
      </div>

      <TagModal
        modal={modalCreate}
        setModal={setModalCreate}
        businessSlug={businessSlug}
        branchId={branchID}
        mode="create"
        initialData={null}
        onSuccess={handleCreateSuccess}
      />

      <TagModal
        modal={modalEdit}
        setModal={setModalEdit}
        businessSlug={businessSlug}
        branchId={branchID}
        mode="edit"
        initialData={editdata}
        onSuccess={handleEditSuccess}
      />

      <ConfirmDeleteModal
        modal={modalConfirmDelete}
        setModal={setModalConfirmDelete}
        businessSlug={businessSlug}
        tagdata={editdata}
        onHide={() => setModalConfirmDelete(prev => ({ ...prev, open: false }))}
        onSuccess={handleDeleteSuccess}
      />

      <SuccessModal
        modal={modalSuccess}
        setModal={setModalSuccess}
        successType={successType}
        onHide={() => setModalSuccess(prev => ({ ...prev, open: false }))}
      />
    </>
  );
}
